module.exports = __webpack_public_path__ + "static/img/qybj_06.07c4a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equity/qybj_06.jpg
// module id = tmf1
// module chunks = 0